import { Expose } from "class-transformer";

export class CreateElevatorDto {
  @Expose()
  name: string;

  @Expose()
  qualificationId?: string;
}
